import type { ReactNode, Ref, TableHTMLAttributes } from "react";
import "./data-table.css";

type Props = Omit<TableHTMLAttributes<HTMLTableElement>, "aria-busy" | "children"> & {
  /** La didascalia della tabella: c'è sempre, anche quando non si vede. */
  caption: ReactNode;
  /** La didascalia resta per gli screen reader ma non si vede (il titolo della finestra la dice già). */
  captionHidden?: boolean;
  /** Mentre arrivano i dati: `aria-busy` sulla tabella. */
  busy?: boolean;
  /** Di base la tabella sta nel suo riquadro che scorre di lato (`g-table-wrap`); `false` se il riquadro lo dà già chi la usa. */
  wrapped?: boolean;
  /** Si aggiunge a `g-table` (per le larghezze delle colonne di quella tabella). */
  className?: string;
  /** `<thead>`, `<tbody>`, `<tfoot>`. */
  children: ReactNode;
  ref?: Ref<HTMLTableElement>;
};

// La tabella semplice del design system, con lo stesso aspetto di DataTable ma senza imporre la prima colonna
// come intestazione di riga: per le tabelle di una finestra (archivio, pulizia, storico).
export function Table({ caption, captionHidden = false, busy = false, wrapped = true, className, children, ...rest }: Props) {
  const table = (
    <table className={className ? `g-table ${className}` : "g-table"} aria-busy={busy ? "true" : undefined} {...rest}>
      <caption className={captionHidden ? "g-visually-hidden" : undefined}>{caption}</caption>
      {children}
    </table>
  );
  return wrapped ? <div className="g-table-wrap">{table}</div> : table;
}
